import React from 'react'
const Icon = () => (
  <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_18_776)">
      <path
        d="M19.8666 8.65185C18.1449 10.6036 16.1179 12.3313 13.811 13.7567C13.1461 14.1675 12.4578 14.5534 11.7467 14.9123L10.9655 15.3065C7.9456 16.8307 6.73306 20.5144 8.25723 23.5343C9.62377 26.2419 12.7262 27.4966 15.5298 26.6287C16.5976 27.8789 17.7736 29.008 19.0363 30.009C20.0473 30.8105 21.4739 30.5038 22.1444 29.48L22.6288 28.7403C23.2783 27.7485 23.0056 26.4687 22.1355 25.7638C21.6163 25.3432 21.1162 24.895 20.6375 24.4199C22.7702 23.6808 24.9483 23.2241 27.1256 23.0345C26.741 20.3936 25.93 17.7688 24.6613 15.255C23.3926 12.7413 21.7627 10.5298 19.8666 8.65185Z"
        fill="#424242"
      />
      <path
        d="M20.9854 7.2969C23.0605 9.32808 24.8423 11.7297 26.2236 14.4665C27.6049 17.2034 28.4787 20.0633 28.8802 22.9392C28.9077 23.1367 28.9333 23.3342 28.9564 23.5318C29.0126 24.0118 29.4472 24.3553 29.9272 24.2992C30.4072 24.243 30.7507 23.8083 30.6946 23.3284C30.6393 22.8564 30.5722 22.3846 30.4931 21.9135C30.1518 19.8814 29.5872 17.8615 28.7885 15.8873C29.0439 15.0547 28.9911 14.124 28.5671 13.2838C28.143 12.4437 27.4256 11.8483 26.6041 11.5592C25.4904 9.74413 24.2007 8.09014 22.7686 6.60861C22.4366 6.26511 22.0969 5.93089 21.75 5.6061C21.3973 5.27582 20.8435 5.29405 20.5133 5.64681C20.183 5.99958 20.2012 6.5533 20.554 6.88358C20.6992 7.01954 20.8429 7.15744 20.9854 7.2969Z"
        fill="#424242"
      />
    </g>
    <defs>
      <clipPath id="clip0_18_776">
        <rect
          width="28"
          height="28"
          fill="white"
          transform="translate(0 12.9998) rotate(-26.7804)"
        />
      </clipPath>
    </defs>
  </svg>
)
export default Icon
